import { createRoot } from "react-dom/client";
import App from "./App";
import { restoreSession } from "./lib/session";

restoreSession();
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

